import dayjs, { Dayjs } from 'dayjs'

export const CHILD_AGE_LIMIT = 15

/**
 * D.1 is for patients aged 15 and over, D.2 for children under 15, by age on the collection date (4.1),
 * or today when it is empty — the same rule as the API.
 */
export const isChildOn = (birthDate?: Dayjs | null, onDate?: Dayjs | null) => {
  if (!birthDate?.isValid()) return false

  return (onDate ?? dayjs()).diff(birthDate, 'year') < CHILD_AGE_LIMIT
}
